import { ScrollView } from 'react-native';
import { Box } from '@/components/ui/primitives';
import AppHeader from '@/components/AppHeader';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { useLeagueContext } from '@/contexts/LeagueContext';
import Leaderboard from '@/components/Leaderboard';
import { leagueRouteStyles } from '@/components/route/leagueRouteStyles';

export default function LeagueLeaderboardRoute() {
  const context = useLeagueContext();

  const {
    id,
    resolvedSeasonId,
    league,
    leagueScoringSystem,
  } = context;

  const headerTitle = league?.name ?? 'League';

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        <ScrollView style={leagueRouteStyles.flex} contentContainerStyle={leagueRouteStyles.content}>
          <Leaderboard
            leagueId={id}
            scoringSystem={leagueScoringSystem}
            seasonId={resolvedSeasonId ?? undefined}
          />
        </ScrollView>
      </Box>
    </NativeTabFocusGate>
  );
}
